import React, { Component } from 'react';
import { SubMenuLink } from "../../SubMenuLink";

export default class MyEbox extends Component {

  render() {
    return <SubMenuLink pathname="/e_box" title="mailbox" icon="MAILBOX_LIGHT" />;
  }
};
